import { render, staticRenderFns } from "./retailOrderList.vue?vue&type=template&id=3f384b54"
import script from "./retailOrderList.vue?vue&type=script&lang=js"
export * from "./retailOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports